import { useEffect, useState } from 'react';
import api from '../api';

export default function AdminDashboard() {
  const [stats, setStats]         = useState(null);
  const [costos, setCostos]       = useState(null);
  const [proyeccion, setProyeccion] = useState(null);
  const [servidor, setServidor]   = useState(null);

  const cargarServidor = () => api.get('/admin/servidor-voz').then(r => setServidor(r.data)).catch(() => {});
  useEffect(() => {
    api.get('/admin/stats').then(r => setStats(r.data)).catch(() => {});
    api.get('/admin/costos-operativos').then(r => setCostos(r.data)).catch(() => {});
    api.get('/admin/proyeccion-saldo').then(r => setProyeccion(r.data)).catch(() => {});
    cargarServidor();
    const iv = setInterval(cargarServidor, 30000);
    return () => clearInterval(iv);
  }, []);

  const fmt = (n) => Number(n || 0).toLocaleString('es-CO', { minimumFractionDigits: 0 });

  return (
    <div>
      <h1 style={{ fontSize: 22, fontWeight: 700, color: 'var(--text)', marginBottom: 4 }}>Panel Administrativo</h1>
      <p style={{ color: 'var(--text-3)', marginBottom: 24, fontSize: 13 }}>Vista general de InnovaCall · {costos?.periodo}</p>

      {/* Métricas generales */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))', gap: 12, marginBottom: 24 }}>
        {[
          { label: 'Clientes',      value: stats?.total_clientes || '-',            color: 'var(--text)' },
          { label: 'Saldo total',   value: `$${fmt(stats?.saldo_total_cop)} COP`,   color: 'var(--text)' },
          { label: 'Llamadas mes',  value: costos?.llamadas_total || '-',            color: 'var(--text)' },
          { label: 'Minutos mes',   value: `${costos?.minutos_total || 0} min`,     color: 'var(--text)' },
          { label: 'Ingresos mes',  value: `$${fmt(costos?.general?.ingresos_cop)} COP`, color: 'var(--text)' },
          { label: 'Costo total',   value: `$${fmt(costos?.general?.costo_total_cop)} COP`, color: 'var(--text)' },
          { label: 'Margen',        value: `${costos?.general?.margen_pct || 0}%`,  color: 'var(--text)' },
          { label: 'Ganancia neta', value: `$${fmt(costos?.general?.margen_cop)} COP`, color: 'var(--text)' },
        ].map((c, i) => (
          <div key={i} style={{ background: 'var(--bg)', border: '1px solid var(--surface)', borderRadius: 10, padding: '16px' }}>
            <div style={{ fontSize: 10, color: 'var(--text-3)', textTransform: 'uppercase', letterSpacing: '.08em', marginBottom: 6 }}>{c.label}</div>
            <div style={{ fontSize: 18, fontWeight: 700, color: c.color }}>{c.value}</div>
          </div>
        ))}
      </div>

      {/* Servidor de voz (pod GPU on-demand) */}
      <div className="ic-card" style={{ background:'var(--bg)', border:'1px solid var(--surface)', borderRadius:12, padding:20, marginBottom:24 }}>
        <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:16, gap:12, flexWrap:'wrap' }}>
          <h2 style={{ color:'var(--text)', fontSize:14, fontWeight:700, margin:0 }}>Servidor de voz</h2>
          <div style={{ display:'flex', alignItems:'center', gap:12 }}>
            <span style={{ fontSize:12, fontWeight:600, display:'flex', alignItems:'center', gap:6,
              color: servidor?.on ? 'var(--success)' : 'var(--text-3)' }}>
              <span style={{ width:8, height:8, borderRadius:'50%', background: servidor?.on ? 'var(--success)' : 'var(--text-3)',
                boxShadow: servidor?.on ? '0 0 8px var(--success)' : 'none' }}/>
              {servidor?.on ? 'Encendido' : 'Apagado'}
            </span>
            <button onClick={cargarServidor} style={{ background:'var(--glass)', border:'1px solid var(--glass-brd)', color:'var(--text-2)', borderRadius:8, padding:'5px 11px', fontSize:12, cursor:'pointer' }}>↻ Actualizar</button>
          </div>
        </div>
        <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit, minmax(130px,1fr))', gap:10 }}>
          {[
            ['GPU en uso',         servidor?.gpu || '—'],
            ['Costo por hora',     servidor?.cost_hr != null ? `$${servidor.cost_hr}/h` : '—'],
            ['Tiempo encendido',   servidor?.on ? `${servidor.uptime_min || 0} min` : '—'],
            ['Costo de la sesión', servidor?.session_cost_usd != null ? `$${Number(servidor.session_cost_usd).toFixed(2)}` : '—'],
            ['Saldo RunPod',       servidor?.balance_usd != null ? `$${Number(servidor.balance_usd).toFixed(2)}` : '—'],
          ].map(([label, val], i) => (
            <div key={i} style={{ background:'var(--surface-3)', borderRadius:8, padding:'10px 12px' }}>
              <div style={{ fontSize:10, color:'var(--text-3)', textTransform:'uppercase', letterSpacing:'.06em', marginBottom:5 }}>{label}</div>
              <div className="num" style={{ fontSize:15, fontWeight:700, color:'var(--text)' }}>{val}</div>
            </div>
          ))}
        </div>
        <div style={{ fontSize:11, color:'var(--text-3)', marginTop:12 }}>
          On-demand: se enciende al lanzar campaña y se apaga tras 30 min sin llamadas. Tope $1/hora, busca la GPU disponible más conveniente.
        </div>
      </div>

      {/* Desglose de costos generales */}
      {costos?.general && (
        <div className="ic-card" style={{ background: 'var(--bg)', border: '1px solid var(--surface)', borderRadius: 12, padding: 20, marginBottom: 24 }}>
          <h2 style={{ color: 'var(--text)', fontSize: 14, fontWeight: 700, margin: '0 0 16px' }}>Desglose de costos operativos</h2>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: 10 }}>
            {[
              { label: 'Liwa SIP',     value: costos.general.liwa_cop,        color: 'var(--accent-solid)', pct: Math.round(costos.general.liwa_cop / costos.general.costo_total_cop * 100) },
              { label: 'OpenAI+Deepgram', value: costos.general.ai_cop,       color: 'var(--accent)', pct: Math.round(costos.general.ai_cop / costos.general.costo_total_cop * 100) },
              { label: 'Total costo',  value: costos.general.costo_total_cop, color: 'var(--text-3)', pct: 100 },
              { label: 'Ganancia',     value: costos.general.margen_cop,      color: 'var(--teal)', pct: costos.general.margen_pct },
            ].map((item, i) => (
              <div key={i} style={{ background: 'var(--surface)', borderRadius: 8, padding: 14 }}>
                <div style={{ fontSize: 10, color: 'var(--text-3)', marginBottom: 6 }}>{item.label}</div>
                <div style={{ fontSize: 16, fontWeight: 700, color: item.color }}>${fmt(item.value)} COP</div>
                <div style={{ fontSize: 10, color: 'var(--text-3)', marginTop: 4 }}>{item.pct}%</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Por cliente */}
      {costos?.por_cliente?.length > 0 && (
        <div className="ic-card" style={{ background: 'var(--bg)', border: '1px solid var(--surface)', borderRadius: 12, padding: 20 }}>
          <h2 style={{ color: 'var(--text)', fontSize: 14, fontWeight: 700, margin: '0 0 16px' }}>Rentabilidad por cliente</h2>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid var(--surface)' }}>
                {['Cliente', 'Llamadas', 'Minutos', 'Ingresos', 'Liwa', 'IA', 'Costo total', 'Ganancia', 'Margen'].map(h => (
                  <th key={h} style={{ padding: '8px 12px', textAlign: 'left', fontSize: 10, color: 'var(--text-3)', textTransform: 'uppercase' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {costos.por_cliente.map((c, i) => (
                <tr key={i} style={{ borderBottom: '1px solid var(--surface-3)' }}>
                  <td style={{ padding: '12px', color: 'var(--text)', fontWeight: 600, fontSize: 13 }}>{c.nombre}</td>
                  <td style={{ padding: '12px', color: 'var(--text-2)', fontSize: 13 }}>{c.llamadas}</td>
                  <td style={{ padding: '12px', color: 'var(--text-2)', fontSize: 13 }}>{c.minutos}</td>
                  <td style={{ padding: '12px', color: 'var(--success)', fontWeight: 600, fontSize: 13 }}>${fmt(c.ingresos_cop)}</td>
                  <td style={{ padding: '12px', color: 'var(--warning)', fontSize: 13 }}>${fmt(c.costos.liwa_cop)}</td>
                  <td style={{ padding: '12px', color: 'var(--accent)', fontSize: 13 }}>${fmt(c.costos.ai_cop)}</td>
                  <td style={{ padding: '12px', color: 'var(--danger)', fontSize: 13 }}>${fmt(c.costos.total_cop)}</td>
                  <td style={{ padding: '12px', color: 'var(--warning)', fontWeight: 600, fontSize: 13 }}>${fmt(c.margen_cop)}</td>
                  <td style={{ padding: '12px', fontSize: 13 }}>
                    <span style={{
                      color: c.margen_pct > 60 ? 'var(--success)' : c.margen_pct > 40 ? 'var(--warning)' : 'var(--danger)',
                      fontWeight: 700
                    }}>{c.margen_pct}%</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Proyeccion de saldo y costo de recarga */}
      {proyeccion?.clientes?.length > 0 && (
        <div className="ic-card" style={{ background: 'var(--bg)', border: '1px solid var(--surface)', borderRadius: 12, padding: 20, marginTop: 24 }}>
          <h2 style={{ color: 'var(--text)', fontSize: 14, fontWeight: 700, margin: '0 0 4px' }}>Proyección de saldo y recarga</h2>
          <p style={{ color: 'var(--text-3)', fontSize: 11, margin: '0 0 16px' }}>
            Minutos restantes por cliente y costo real estimado de entregarlos, según el promedio de sus últimas llamadas.
          </p>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 12, marginBottom: 18 }}>
            <div style={{ background: 'var(--surface)', borderRadius: 8, padding: 14 }}>
              <div style={{ fontSize: 10, color: 'var(--text-3)', marginBottom: 6 }}>Minutos restantes (total)</div>
              <div style={{ fontSize: 18, fontWeight: 700, color: 'var(--text)' }}>{fmt(proyeccion.totales.minutos_restantes_total)} min</div>
            </div>
            <div style={{ background: 'var(--surface)', borderRadius: 8, padding: 14 }}>
              <div style={{ fontSize: 10, color: 'var(--text-3)', marginBottom: 6 }}>Necesitas tener en proveedores</div>
              <div style={{ fontSize: 18, fontWeight: 700, color: 'var(--text)' }}>${fmt(proyeccion.totales.costo_estimado_recarga_total_cop)} COP</div>
            </div>
          </div>

          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '1px solid var(--surface)' }}>
                {['Cliente', 'Saldo', 'Min. restantes', 'Deepgram', 'OpenAI', 'Liwa', 'Recarga total', ''].map(h => (
                  <th key={h} style={{ padding: '8px 12px', textAlign: 'left', fontSize: 10, color: 'var(--text-3)', textTransform: 'uppercase' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {proyeccion.clientes.map((c, i) => {
                const muestraBaja = c.muestra_llamadas > 0 && c.muestra_llamadas < 20;
                return (
                  <tr key={i} style={{ borderBottom: '1px solid var(--surface-3)' }}>
                    <td style={{ padding: '12px', color: 'var(--text)', fontWeight: 600, fontSize: 13 }}>{c.nombre}</td>
                    <td style={{ padding: '12px', color: 'var(--text-2)', fontSize: 13 }}>${fmt(c.saldo_cop)}</td>
                    <td style={{ padding: '12px', color: 'var(--text)', fontWeight: 600, fontSize: 13 }}>{fmt(c.minutos_restantes)} min</td>
                    <td style={{ padding: '12px', color: 'var(--accent)', fontSize: 13 }}>
                      {c.recarga_por_proveedor?.deepgram_cop != null ? `$${fmt(c.recarga_por_proveedor.deepgram_cop)}` : '-'}
                    </td>
                    <td style={{ padding: '12px', color: 'var(--success)', fontSize: 13 }}>
                      {c.recarga_por_proveedor?.openai_cop != null ? `$${fmt(c.recarga_por_proveedor.openai_cop)}` : '-'}
                    </td>
                    <td style={{ padding: '12px', color: 'var(--warning)', fontSize: 13 }}>
                      {c.recarga_por_proveedor?.liwa_cop != null ? `$${fmt(c.recarga_por_proveedor.liwa_cop)}` : '-'}
                    </td>
                    <td style={{ padding: '12px', color: 'var(--danger)', fontWeight: 600, fontSize: 13 }}>
                      {c.costo_estimado_recarga_cop != null ? `$${fmt(c.costo_estimado_recarga_cop)}` : '-'}
                    </td>
                    <td style={{ padding: '12px', fontSize: 11 }}>
                      {muestraBaja && (
                        <span title={`Solo ${c.muestra_llamadas} llamadas en la muestra — dato poco confiable`} style={{
                          color: 'var(--warning)', background: 'rgba(245,158,11,0.1)', border: '1px solid rgba(245,158,11,0.25)',
                          borderRadius: 6, padding: '3px 7px', fontWeight: 600, whiteSpace: 'nowrap',
                        }}>⚠ muestra baja ({c.muestra_llamadas})</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
